module.exports = __webpack_public_path__ + "img/balloon2_n.0dbece74.png";